import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IconComponent } from './icon.component';
import { PreserveSvgMaskUrlDirective } from './preserve-svg-mask-url/preserve-svg-mask-url.directive';

@NgModule({
  imports: [MatIconModule, CommonModule, PreserveSvgMaskUrlDirective],
  exports: [IconComponent],
  declarations: [IconComponent],
})
export class IconModule {}
